import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, LanguageSwitcher, CurrencySwitcher, ExternalLink } from '../../components';
import { isStagingMarketplaceBuild } from '../../util/marketplaceOrigin';
import css from './CustomFooter.module.css';

const CustomFooter = () => {
  const showStagingBadge = isStagingMarketplaceBuild();

  return (
    <footer className={css.root}>
      <div className={css.container}>
        <div className={css.content}>
          {/* Main Footer Content */}
          <div className={css.mainSection}>
            <div className={css.brandSection}>
              <div className={css.logo}>
                <ExternalLink href="https://findyourkind.com/" className={css.logoLink}>
                  <img
                    className={css.logoImage}
                    src="https://cdn.prod.website-files.com/6869ea75538ac2811877426d/686db9e90873d8b34a19a86f_logo.jpeg"
                    alt="Find Your Kind"
                  />
                </ExternalLink>
              </div>
              <p className={css.tagline}>
                Trusted help, sent on your behalf.
              </p>
              <div className={css.enquiries}>
                <p className={css.enquiryLine}>Australian enquiries: +61415769422</p>
                <p className={css.enquiryLine}>UK enquiries: +447919914929</p>
              </div>
            </div>

            <div className={css.linksSection}>
              <div className={css.linkGroup}>
                <h3 className={css.linkGroupTitle}>About Find your kind</h3>
                <ul className={css.linkList}>
                  <li><ExternalLink href="https://findyourkind.com/" className={css.link}>Home</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/about" className={css.link}>About</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/how-it-works" className={css.link}>How it works</ExternalLink></li>
                </ul>
              </div>

              <div className={css.linkGroup}>
                <h3 className={css.linkGroupTitle}>Who we are</h3>
                <ul className={css.linkList}>
                  <li><ExternalLink href="https://findyourkind.com/team" className={css.link}>Our team</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/blog" className={css.link}>Blog</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/foundation" className={css.link}>Find Your Kind Foundation</ExternalLink></li>
                </ul>
              </div>

              <div className={css.linkGroup}>
                <h3 className={css.linkGroupTitle}>Vouchers</h3>
                <ul className={css.linkList}>
                  <li><NamedLink name="VoucherPurchasePage" className={css.link}>Buy Vouchers</NamedLink></li>
                  <li><ExternalLink href="https://findyourkind.com/s" className={css.link}>Redeem Vouchers</ExternalLink></li>
                </ul>
              </div>

              <div className={css.linkGroup}>
                <h3 className={css.linkGroupTitle}>Help & support</h3>
                <ul className={css.linkList}>
                  <li><ExternalLink href="https://findyourkind.com/faqs" className={css.link}>FAQs</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/contact" className={css.link}>Contact us</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/help-support/terms-and-conditions" className={css.link}>Terms & Conditions</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/help-support/privacy-policy" className={css.link}>Privacy Statement</ExternalLink></li>
                  <li><ExternalLink href="https://findyourkind.com/help-support/become-a-crew-member" className={css.link}>Become a Crew Member</ExternalLink></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className={css.bottomSection}>
          <div className={css.abnLine}>Find Your Kind ABN 76 690 017 237</div>
          <div className={css.versionLine}>
            {showStagingBadge ? (
              <span className={css.stagingBadge} data-testid="footer-staging-badge">
                STAGING
              </span>
            ) : null}
            <span>v2.1</span>
          </div>
        </div>
        </div>
    
    </footer>
  );
};

export default CustomFooter; 